import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Button } from 'react-bootstrap';
import { useNavigate,  useParams } from "react-router-dom";
import { SurveyItem } from '../types/index';
import { getSurveyByIdAndPersonAPI } from '../api/surveyAPI';
import { useTranslation } from "react-i18next";

export default function SurveyEnd() {
    const { idSurvey, order } = useParams();
    const [itemSurvey, setItemSurvey] = useState<SurveyItem | null>(null);


    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = async () => {
            try {
                await loadSurvey(Number(order));
            } catch (error) {
                console.error(error);

            } finally {
                console.log("loaded");
            }
        }

        fetchData()
    }, [])

    const loadSurvey = (orderParam: number) => {
        getSurveyByIdAndPersonAPI( Number(idSurvey), 1)
            .then(response => {
                setItemSurvey(response);
                console.log(response.description)
            })
            .catch(error => {
                console.error('Error fetching pending surveys', error);
            });

    }

    const handleBack = () => {
        navigate("/pending-surveys");
    }

    return (
        <>
            <Row className="d-flex flex-wrap">
                <Col className="d-flex" style={{ padding: "0" }}>
                    <Container>
                        <Row className="w-100 align-items-center" style={{ margin: "0" }}>

                            <Col xs={6} md={6} className="d-flex align-items-center" style={{ padding: "0" }}>
                                <img
                                    src="/ilustracio-craiteria-public.png"
                                    alt="Craiteria"
                                    style={{ width: '240px', height: 'auto', objectFit: 'cover', backgroundColor: '#FFF' }}
                                />
                            </Col>

                            <Col xs={6} md={6} className="d-flex flex-column h1-enquesta" >
                                {itemSurvey !== null ? itemSurvey.description : ""}
                            </Col>
                        </Row>
                        <Row className="w-100" style={{ margin: "0" }}>
                            <Container>
                                <Row>
                                    <div className="d-flex question" >{t("surveyEndLayoutMessageFinish")}<br /><br />
                                        {t("surveyEndLayoutMessageGratitude")}</div>
                                </Row>
                                
                                <Row className="btns-margin">
                                    <Col>
                                        <Button variant="success" className="w-100" onClick={handleBack}>
                                            Torna
                                        </Button>
                                    </Col>
                                </Row>
                            </Container>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </>
               
    );
}